// Reusable LocalBusiness schema utility for all pages

export const getLocalBusinessSchema = (pageType: 'home' | 'service' | 'location' | 'blog' | 'other' = 'other') => {
  const baseSchema = {
    "@context": "https://schema.org",
    "@type": "HousePainter",
    "@id": "https://danispainting.net/#organization",
    "name": "Danis Painting Co.",
    "alternateName": "Mark Danis DBA Danis Painting",
    "url": "https://danispainting.net",
    "logo": "https://danispainting.net/logo.png",
    "image": "https://danispainting.net/logo.png",
    "description": "Professional painting and waterproofing services in Santa Barbara, Ventura, and Los Angeles. Over 30 years of exceptional quality and craftsmanship.",
    "telephone": "+1-805-403-8727",
    "email": "danispainting@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "133 E De La Guerra St, #267",
      "addressLocality": "Santa Barbara",
      "addressRegion": "CA",
      "postalCode": "93101",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "34.4208",
      "longitude": "-119.6982"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59"
      }
    ],
    "priceRange": "$$",
    "paymentAccepted": ["Cash", "Check", "Credit Card", "Debit Card", "Visa", "Mastercard", "American Express"],
    "areaServed": [
      {
        "@type": "City",
        "name": "Santa Barbara",
        "@id": "https://en.wikipedia.org/wiki/Santa_Barbara,_California"
      },
      {
        "@type": "City",
        "name": "Ventura",
        "@id": "https://en.wikipedia.org/wiki/Ventura,_California"
      },
      {
        "@type": "City",
        "name": "Montecito"
      },
      {
        "@type": "City",
        "name": "Goleta"
      },
      {
        "@type": "City",
        "name": "Carpinteria"
      },
      {
        "@type": "City",
        "name": "Ojai"
      },
      {
        "@type": "City",
        "name": "Camarillo"
      },
      {
        "@type": "City",
        "name": "Solvang"
      },
      {
        "@type": "City",
        "name": "Buellton"
      },
      {
        "@type": "City",
        "name": "Santa Ynez"
      },
      {
        "@type": "City",
        "name": "Isla Vista"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Painting and Waterproofing Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Roof Coating & Repair",
            "description": "Comprehensive roof services with GE Enduris High Solids coating. Flame-retardant protection."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Interior & Exterior Painting",
            "description": "Precision painting of walls and ceilings with premium finishes."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Cabinet Painting",
            "description": "Kitchen and bathroom cabinet transformation with professional finishes."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Waterproofing",
            "description": "Comprehensive waterproofing solutions for decks, balconies, and exterior surfaces."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pressure Washing",
            "description": "Professional cleaning services for surfaces before painting or maintenance."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Drywall Repair",
            "description": "Expert drywall patching and repair services."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Commercial Painting",
            "description": "Professional commercial painting services for offices, retail stores, restaurants, warehouses, and industrial facilities. Licensed California contractor with 30+ years experience. Flexible evening and weekend scheduling to minimize business disruption. Commercial-grade paints, epoxy coatings, and specialized finishes. Serving Santa Barbara, Ventura, and Los Angeles counties.",
            "provider": {
              "@type": "PaintingContractor",
              "name": "Danis Painting Co."
            },
            "areaServed": [
              "Santa Barbara",
              "Ventura",
              "Montecito",
              "Goleta",
              "Carpinteria",
              "Ojai",
              "Camarillo",
              "Solvang",
              "Buellton",
              "Santa Ynez",
              "Isla Vista"
            ],
            "serviceType": "Commercial Painting",
            "category": "Commercial Services"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "24",
      "bestRating": "5",
      "worstRating": "1"
    },
    "founder": {
      "@type": "Person",
      "name": "Mark Danis"
    },
    "foundingDate": "1995",
    "slogan": "Honest New England Quality",
    "knowsAbout": ["Painting", "Waterproofing", "Roof Coating", "Cabinet Refinishing", "Pressure Washing", "Drywall Repair", "Commercial Painting"],
    "sameAs": [
      "https://www.facebook.com/61568678263513",
      "https://www.yelp.com/biz/danis-painting-santa-barbara-4"
    ],
    "hasCredential": {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "license",
      "name": "California Contractor License",
      "identifier": "662554",
      "recognizedBy": {
        "@type": "Organization",
        "name": "California Contractors State License Board"
      }
    },
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "License Number",
        "value": "LIC #662554"
      },
      {
        "@type": "PropertyValue",
        "name": "Issuing Authority",
        "value": "California Contractors State License Board (CSLB)"
      }
    ]
  };

  // Return base schema for all pages
  return baseSchema;
};

export const injectSchema = (schema: object, schemaId: string = 'page-schema') => {
  let script = document.querySelector(`script[type="application/ld+json"]#${schemaId}`) as HTMLScriptElement;
  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = schemaId;
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(schema);

  return () => {
    const existingScript = document.querySelector(`script[type="application/ld+json"]#${schemaId}`);
    if (existingScript) {
      existingScript.remove();
    }
  };
};
